import { render, staticRenderFns } from "./CustomerProductsList.vue?vue&type=template&id=71bda108&"
import script from "./CustomerProductsList.vue?vue&type=script&lang=ts&"
export * from "./CustomerProductsList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerProductsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VEditDialog,VSkeletonLoader,VTextField,VTooltip})
